<template>
	<div
		class="attachment-wrapper"
		v-if="attachments && attachments.length > 0"
	>
		<a
			v-for="attachment in attachments"
			:key="attachment.attachmentId"
			class="attachment"
			:class="{ 'attachment-create': isCreate }"
			@click="downloadFile(attachment)"
		>
			<mdb-icon icon="paperclip" class="attachment-icon" />
			<span>{{ attachmentOriginalName(attachment.name) }}</span>
			<div
				v-if="isCreate"
				@click.prevent.stop="deleteAttachment(attachment.attachmentId)"
				class="delete-icon-wrapper"
			>
				<mdb-icon icon="times" class="delete-icon" />
			</div>
		</a>
	</div>
</template>

<script>
import { mdbIcon } from 'mdbvue'
import { getDownloadSignedUrl } from '@/services/S3Service.js'
import { saveAs } from 'file-saver'

export default {
	components: {
		mdbIcon
	},
	props: {
		isCreate: {
			type: Boolean,
			default: true
		},
		attachments: {
			type: Array
		}
	},
	methods: {
		deleteAttachment(attachmentId) {
			const newAttachments = this.attachments.filter(attachment => {
				return attachment.attachmentId !== attachmentId
			})
			this.$emit('input', newAttachments)
		},
		async downloadFile(attachment) {
			const token = sessionStorage.getItem('token')
			const folder = attachment.folder
			const name = attachment.name
			const fileName = this.attachmentOriginalName(name)

			try {
				const response = await getDownloadSignedUrl(folder, name, token)
				const URL = response.data.url

				var popup = window.open(URL, '_blank', '', true)

				if (!popup) {
					fetch(URL)
						.then(response => {
							return response.blob()
						})
						.then(blob => {
							saveAs(blob, fileName)
						})
				} else {
					popup.onload = function() {
						setTimeout(function() {
							if (popup.outerHeight === 0) {
								fetch(URL)
									.then(response => {
										return response.blob()
									})
									.then(blob => {
										saveAs(blob, fileName)
									})
							} else {
								popup.close()
							}
						}, 25)
					}
				}
			} catch (e) {
				console.log(e)
			}
		},
		attachmentOriginalName(fileName) {
			const fileNameArray = fileName.split('.')
			const fileNameArrayLength = fileNameArray.length
			const nameArray = fileNameArray[fileNameArrayLength - 2].split('-')
			const nameArrayLength = nameArray.length
			nameArray.splice(nameArrayLength - 1, 1)
			fileNameArray[fileNameArrayLength - 2] = nameArray.join('-')
			const originalFileName = fileNameArray.join('.')
			return originalFileName
		}
	}
}
</script>

<style lang="scss" scoped>
@import '../styles/components/baseAttachment.scss';
</style>
